export default {
    homeTitle: '首页',
    tech: '技术报告',
    service: '服务',
    login: {
        isLoading: '加载中…',
        errorVideoTip: '加载失败',
        errorTip1: '请输入验证码',
        errorTip2: '请输入数字',
        errorTip3: '请输入6位数字',
        errorTip4: '请输入邮箱',
        errorTip5: '邮箱格式不正确',
        successTip1: '登录成功',
        input1: '请输入手机号',
        input2: '请输入6位验证码',
        input3: '请输入国家名称',
        input4: '请输入邮箱',
        reSend: '后重新发送',
        getCode: '获取验证码',
        register: '注册',
        login: '立即登录',
        tipTitle: '温馨提示',
        tip1: '智源Brain平台仅向部分用户开放体验，请使用智源社区账号登录（二维码扫描一次后失效）。',
        tip2: '测试期间，登录即代表同意',
        tip3: '和',
    },
    register: {
        errorTip1: '手机号格式不正确',
        errorTip2: '邮箱格式不正确',
        successTip1: '注册成功，请登录',
        title: '用户注册',
        name: '姓名',
        namePlaceholder: '请输入姓名',
        phone: '手机号',
        phonePlacholder: '请输入手机号',
        email: '邮箱',
        emailPlacholder: '请输入邮箱',
        company: '所属机构/单位',
        companyPlaceholder: '请输入所属机构/单位',
        institutionType: '机构类型',
        institutionTypePlaceholder: '请选择机构类型',
        position: '职位/职称',
        positionPlaceholder: '请输入职位/职称',
        academicField: '学术领域/研究方向',
        academicFieldPlaceholder: '请输入学术领域/研究方向',
        deparment: '部门',
        departmentPlaceholder: '请输入部门名称',
        tip1: '本人已阅读并接受智源研究院Brain平台',
        tip2: '和',
        tip3: '，请填写真实信息，否则无法通过申请。',
        cancel: '取消',
        register: '注册',
        registerWarning: '请阅读和同意协议'
    },
    common: {
        home: '首页',
        joinUs: 'Brain',
        aboutUs: 'Brain',
        aboutUs1: '技术报告',
        userCenter: '个人中心',
        logout: '退出登录',
        guide: '使用指南',
        login: '登录',
        register: '注册',
        uploadSuccess: '上传成功',
        uploadFailed: '上传失败',
        // agreement1: '《智源Brain平台服务协议》',
        // agreement2: '《AI公测使用须知》',
        // agreement3: '《平台使用说明》',
        // agreement4: '《智源研究院Brain 使用指南》',
        deleteSucess: '删除成功',
        generate: '生成',
        history: '历史记录',
        approval: '审批管理',
        approvalRecord: '审批记录',
        noPermission: '请联系管理员申请权限后重试',
        tip1: '测试期间注册即表示您同意智源研究院Brain平台',
        and: '和',
        agreement1: '《服务条款》',
        agreement2: '《禁止行为政策》',
        agreement3: '《隐私政策》',
        noData: '暂无数据',
        phoneLogin: '手机号登录',
        emailLogin: '邮箱登录',
    },
    // 主页
    home: {
        banner: {
            title: '世界一流的微观生命分子模型',
            btn1: '未来的报告',
            bioTitlePart1: '生物分子',
            bioTitlePart2: '基础',
            bioTitlePart3: '模型',
            bioSubTitle: 'Brain2 融合生成式人工智能与全原子生物分子建模技术，精准预测生物分子结构与相互作用。该创新方法突破静态结构预测的局限，揭示蛋白质动态构象景观，为解析生物功能机制提供深层洞见，加速下一代创新疗法的研发进程',
        },
        intro: {
            // title: '模型介绍',
            // subTitle: '从静态结构预测迈向构象分布，展现分子多样性与变化规律',
            next: {
                ft1: '全原子模型',
                ft2: '大小分子统一',
                ft3: '多体相互作用',
                ft4: '构象分布预测',
            },
            leftInfo: {
                title: '行业主流模型',
                subTitle: '多个模型',
                sevenInfo: ['蛋白质与核酸序列语言模型', '蛋白质、核酸、小分子结构预测模型', '蛋白质构象动态预测模型', '蛋白质功能预测模型', '蛋白质设计生成模型', '小分子对接预测模型', '小分子生化性质预测模型'],
            },
            rightInfo: {
                title: 'Brain 全原子模型',
                subTitle: '单个模型',
                fourInfo: ['统一大小分子理解与生成', '结构预测到分布建模', '助力药物靶点发现及分子设计'],
            },
        },
        performance: {
            title: '模型表现',
            section1: {
                title: '模型成果',
                over: '连续超36个月',
                title2: '在CAMEO蛋白质结构预测竞赛稳居第一（连续超36个月）'
            },
            section2: {
                title: '模型特点',
                subTitle: '具备广泛探索蛋白质构象空间的能力',
                info: '模型赋能方面，已与德国海德堡大学、清华大学、昌平实验室等国内外多家生物实验室以及原子高科等优势药企探讨合作，开展成药性和分子机理研究',
                leftInfo: 'CASP16 23 支参赛队伍中唯一成功预测蛋白质构象分布的队伍',
                rightInfo: '大量采样 Villin 蛋白的 TICA Map',
                leftMolxInfo: 'T1200（野生型）采样构象分布较为紧凑',
                rightMolxInfo: 'T1300（GLY6 突变型）采样构象分布更加广泛',
                info2: 'CASP16 23 支参赛队伍中唯一一支成功预测蛋白质空间构象分布的队伍(定性上与实验数据一致)',
            },
            section3: {
                subTitle: '在蛋白质、DNA、RNA结构预测任务上性能领先',
                desc1: 'RNA结构',
                desc2: 'DNA-蛋白质复合物结构',
                desc3: '蛋白质-蛋白质复合物结构',
            },
            section4: {
                title: '在生物分子相互作用精细化分析上表现优异',
                desc: 'Brain成功预测了该蛋白质与配体之间的两种不同结合位点（PDB ID: 7DT9）',
            }
        },
        application: {
            title: '模型特点',
            more: '了解更多',
            sbt1: '超大对称蛋白建模',
            subInfo1: 'Brain2 引入对称性优化策略，高效精准建模包括二十面体（I）、八面体（O）和四面体（T）在内的大体系复杂对称结构',
            subInfo11: '图示为麻短杆菌二十面体包裹蛋白（PDB ID: 7BCV），包含 15,960 个残基，TM-score 达到 0.903',
            sbt2: '复合物结构预测',
            subInfo2: 'N-肉豆蔻酰转移酶与Indazole抑制剂IMP-917复合物（6tw5）',
            subInfo21: '预测误差 2.1 Å',
            sbt3: '蛋白小分子互作预测',
            subInfo3: 'IclR转录因子与4-羟基苯甲酸复合物结构（PDB ID: 7CUO）',
            subInfo31: 'ligand RMSD小于2 Å',
            sbt4: '构象变化预测',
            subInfo4: 'Brain2 连接了静态结构预测和动态构象分布建模，为理解如激酶等动态蛋白调控机制提供关键线索',
            subInfo41: '图示为 Src 激酶从非激活态到激活态的构象变化（PDB ID: 2SRC → 1Y57）',
            sbt5: '小分子多位点互作预测',
            subInfo5: 'Brain2 能准确预测蛋白与小分子配体的多种结合模式，有助于发现隐蔽口袋，为新药研发提供可靠结构基础',
            subInfo51: '图示为人类 PPARγ 配体结合结构域与全氟辛酸的复合物（PDB ID: 8U57）',
            sbt6: '蛋白基序支架设计（Beta）',
            subInfo6: 'Brain2 通过生成式建模赋能蛋白质设计',
            subInfo61: '图示为来源于细菌的 barstar–barnase 复合物（PDB ID: 7MRX），基于 barstar 关键功能基序，Brain2 设计并构建了全新支架蛋白',
            sbt7: '柔性区域预测',
            subInfo7: 'Brain2 基于全原子的建模策略，在捕捉局部柔性片段构象多样性方面展现出显著优势',
            subInfo71: '图示结构由无序区连接两个结构域（PDB ID: 4NPF），Brain2 能够采样到该区域的柔性构象变化',
            circle1: '蛋白质',
            circle2: '性质',
            circle3: '核酸',
            circle4: '系综',
            circle5: '小分子',
            circle6: '结构',
            intro: {
                titlePart1: '模型',
                titlePart2: '介绍',
                subTitle: '从静态结构预测迈向构象分布，展现分子多样性与变化规律',
                card1: {
                    titlePart1: '高精度',
                    titlePart2: '结构预测',
                    desc: '融合原子、残基与功能基序等不同层级信息，精确构建蛋白质、RNA 和 DNA 单链构象',
                },
                card2: {
                    titlePart1: '精细化',
                    titlePart2: '多体互作预测',
                    desc: '准确预测不同分子尺度范围的多链相互作用，涵盖蛋白质-小分子到大体系蛋白质复合物',
                },
                card3: {
                    titlePart1: '蛋白柔性',
                    titlePart2: '区域建模',
                    desc: '通过全原子基础模型捕捉蛋白质无序区域中复杂的侧链相互作用，揭示柔性区域变化的潜在机制',
                },
                card4: {
                    titlePart1: '高效构象',
                    titlePart2: '系综采样',
                    desc: '通过高效的构象景观采样捕捉关键瞬时构象变化，将“不可成药”蛋白质转化为可行的治疗靶点',
                },
            },
            atom: {
                titlePart1: '全原子',
                titlePart2: '生物分子模型',
                desc: 'Brain2 通过学习原子级分布，精准重建完整分子结构，实现动态构象及关键结合位点的高分辨率建模'
            },
            performance: {
                titlePart1: '模型',
                titlePart2: '性能',
            }
        },
        feature: {
            titlePart1: '模型',
            titlePart2: '特点',
        },
        desc: {
            caspTitle: 'CASP16 23 支参赛队伍中唯一成功预测蛋白质构象分布的队伍',
            leftMolxInfo: 'T1200（野生型）采样构象分布较为紧凑',
            rightMolxInfo: 'T1300（GLY6 突变型）采样构象分布更加广泛',
            section1: {
                title: '在结构预测任务上性能领先',
                subTitle: '蛋白质、DNA、RNA结构预测任务',
                desc1: 'RNA结构',
                desc2: 'DNA-蛋白质复合物结构',
                desc3: '蛋白质-蛋白质复合物结构',
            },
            section2: {
                title: '在生物分子相互作用精细化分析上表现优异',
                desc: 'Brain2 具备识别配体多个结合位点的能力（例如 PDB: 7DT9）',
            }
        },
        sence: {
            title: '应用场景',
            titles: ['化学药物及核药方面', '生物药物方面', '合成生物学方面', '病毒载体方面'],
            infos: [
                '加速药物分子虚拟筛选，提升早期药物发现效率',
                '通过对蛋白质-配体和蛋白质-蛋白质相互作用的分析，优化抗体药物、疫苗设计',
                '通过对蛋白质的精确的理解，推动生物材料、人工酶、生物传感器设计',
                '基于蛋白质结构的精准预测，提升病毒载体的性能',
            ],
        },
    },
};
